import React from "react";
import { Tabs } from "../../../../shared/components/ui/Tabs";
import { WelcomeMessage } from "../../../../shared/components/ui/WelcomeMessage";
import { useGetUserById } from "../../../users/services/userService";
import { useAuthStore } from "../../../../store";
import { UsersTab } from "../../components/UsersTab/UsersTab";
import { BuildingsTab } from "../../components/BuildingsTab/BuildingsTab";
import { useTabState } from "../../../../shared/hooks/useTabState";
import { useUsersTab } from "../../components/UsersTab/useUsersTab";
import { useBuildingsTab } from "../../components/BuildingsTab/useBuildingsTab";
import { NewsPreviewTab } from "../../components/NewsPreviewTab/NewsPreviewTab";
import { useNewsPreviewTab } from "../../components/NewsPreviewTab/useNewsPreviewTab";
import { SwimmersPreviewTab } from "../../components/SwimmersPreviewTab/SwimmersPreviewTab";
import { useSwimmersPreviewTab } from "../../components/SwimmersPreviewTab/useSwimmersPreviewTab";

// Tab identifiers for URL query parameter
const TAB_VALUES = ["usuarios", "unidades-residenciales", "banistas", "novedades"] as const;

export const AdminDashboardPage: React.FC = () => {
  const { user } = useAuthStore();
  const { data: currentUser } = useGetUserById(user?.id ?? "");
  const usersTabLogic = useUsersTab();
  const buildingsTabLogic = useBuildingsTab();
  const newsPreviewTabLogic = useNewsPreviewTab();
  const swimmersPreviewTabLogic = useSwimmersPreviewTab();

  // Manage tab state via URL query parameter
  const [activeTab, setActiveTab] = useTabState({
    defaultTab: 0,
    indexToValue: (index) => TAB_VALUES[index] ?? null,
    valueToIndex: (value) => {
      const index = TAB_VALUES.indexOf(value as typeof TAB_VALUES[number]);
      return index >= 0 ? index : null;
    },
  });

  const tabs = [
    {
      label: "Salvavidas",
      content: <UsersTab {...usersTabLogic} />,
    },
    {
      label: "Unidades",
      content: <BuildingsTab {...buildingsTabLogic} />,
    },
    {
      label: "Bañistas",
      content: <SwimmersPreviewTab {...swimmersPreviewTabLogic} />,
    },
    {
      label: "Novedades",
      content: <NewsPreviewTab {...newsPreviewTabLogic} />,
    },
  ];

  return (
    <div className="flex flex-col gap-4 px-3 sm:px-6 py-0">
      <WelcomeMessage name={currentUser?.name} />
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </div>
  );
};
